import { useInteractionParams } from '../useInteractionParams';

/**
 * A type safe version of `useInteractionParams` that throws if the
 * interaction ID or type can't be determined.
 *
 * ⚠️ This should only be used on pages where the interaction ID and
 * type are guaranteed to exist, i.e. those where the page component
 * does not have `disableInteractionValidation` set to `true`. ⚠️
 */
export function useSafeInteractionParams() {
  const {
    interactionId,
    interactionType,
    childInteractionId,
    childInteractionType,
  } = useInteractionParams();

  if (!interactionId) {
    throw new Error('This page requires an interaction ID');
  }

  if (!interactionType) {
    throw new Error('This page requires an interaction type');
  }

  return {
    interactionId,
    interactionType,
    childInteractionId,
    childInteractionType,
  };
}
